export default "/fonts/poppins-v9-latin-700.svg?935ea13c8ac9481a5f11a12d0773fd7a";